module.exports = __webpack_public_path__ + "img/office-follow.e4e7bc20.jpg";